import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconInfo = ({ className = '', color = '#000000', height = 24, title, width = 24 }: Icon) => (
    <AccessibleSVG
        className={`icon-info ${className}`}
        height={height}
        title={title}
        viewBox="-603 389 16 16"
        width={width}
    >
        <path
            className="fill-color"
            d="M-595 403c5.5 0 8-7.1 3.9-10.6-4.2-3.6-10.8.3-9.8 5.7.5 2.8 3 4.9 5.9 4.9zm.9-6.7v3.7h-1.4v-3.7h1.4zm.1-2.2c0 1-1.7 1.1-1.7 0 .1-1.1 1.7-1.1 1.7 0z"
            fill={color}
            fillRule="evenodd"
        />
    </AccessibleSVG>
);

export default IconInfo;
